import { ISummerCampEnquiry } from '@wot/typings';
import { format, parseISO } from 'date-fns';
import { CheckBox } from '@wot/components';
import Chip from '../../../../components/Chip';
import { TableRowItemData } from '../../../../components/Table';

export default function TableRowItem({
  enquiry,
  selected,
  onSelect
}: {
  enquiry: ISummerCampEnquiry;
  selected: boolean;
  onSelect: (id: string, checked: boolean) => void;
}) {
  return (
    <>
      <td className="w-12 px-4 py-2" onClick={(e) => e.stopPropagation()}>
        <CheckBox defaultValue={selected} onChange={(checked) => onSelect(enquiry._id, checked)} />
      </td>
      <TableRowItemData text={format(parseISO(enquiry.createdAt), 'dd/MM/yyyy')} />
      <TableRowItemData text={enquiry.name} />
      <TableRowItemData text={enquiry.email} />
      <TableRowItemData text={enquiry.phone} />
      <TableRowItemData text={`Program ${enquiry.program}`} />
      <TableRowItemData text={enquiry.source} />
      <TableRowItemData text={enquiry.message?.length > 40 ? enquiry.message.slice(0, 40) + '...' : enquiry.message} />
      <TableRowItemData text={enquiry.notes?.length?.toString() || '0'} />
      <TableRowItemData
        component={
          <Chip
            state={
              enquiry.status === 'new'
                ? 'pending'
                : enquiry.status === 'contacted'
                ? 'warning'
                : enquiry.status === 'converted'
                ? 'success'
                : enquiry.status === 'closed'
                ? 'error'
                : 'pending'
            }
          >
            <p className="text-sm font-semibold capitalize">{enquiry.status}</p>
          </Chip>
        }
      />
    </>
  );
}
